import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { createUseStyles } from 'react-jss'

import BaseLink from 'components/links/BaseLink'

const paddingList = {
  default: '0px 20px 14px 30px',
  appointmentMenu: '0px 30px 10px 30px',
  moreMenu: '5px 30px 5px 30px'
}

const useStyles = createUseStyles(({ colors, typography }) => ({
  menuItem: {
    color: ({ color }) => colors[color],
    flexDirection: 'column',
    fontFamily: typography.fontFamilyVariants.primary,
    fontSize: typography.fontSizeVariants.small,
    fontWeight: ({ fontWeight }) => fontWeight || typography.fontWeightVariants.medium,
    position: 'relative',
    padding: ({ padding }) => paddingList[padding],
    textAlign: 'left',

    '&:hover': {
      backgroundColor: ({ showHoverTextColor }) => !showHoverTextColor ?  colors.PaleBlue: 'none',
      color: ({ showHoverTextColor }) => showHoverTextColor ? colors.secondary : 'none'
    }
  }
}))

function MenuItem({
  children,
  className,
  onClick,
  to,
  href,
  color,
  padding,
  showHoverTextColor,
  fontWeight
}) {
  const classes = useStyles({ color, padding, showHoverTextColor, fontWeight })

  return (
    <BaseLink
      className={classNames(classes.menuItem, className)}
      onClick={onClick}
      to={to}
      href={href}
      role="menuitem"
    >
      {children}
    </BaseLink>
  )
}

MenuItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string,
  href: PropTypes.string,
  color: PropTypes.string,
  padding: PropTypes.oneOf(['default', 'appointmentMenu', "moreMenu"]),
  showHoverTextColor: PropTypes.bool
}

MenuItem.defaultProps = {
  className: null,
  onClick: () => {},
  to: null,
  href: null,
  color: 'dark',
  padding: 'default',
  showHoverTextColor: true
}

export default MenuItem
